import { motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';
import { AdContext } from '../../App';

import { AnimatedGuide } from '../AnimatedGuide';
import { AthleteProfile } from '../AthleteProfile';
import { CheckpointResults } from '../CheckpointResults';
import { HeadToHead } from '../HeadToHead';
import { ImageWithDropDown } from '../ImageWithDropDown';
import { JudgesHeadToHead } from '../JudgesHeadToHead';
import { JudgesResults } from '../JudgesResults';
import { KnockOutTree } from '../KnockOutTree';
import { KnockOutTree2 } from '../KnockOutTree2';
import { Results } from '../Results';
import { SimpleTrack } from '../SimpleTrack';
import { WipeAdvertisement } from './Partials/wipe-advertisement';

const Wipe = ({ config }) => {
  const allComponents = {
    animatedguide: AnimatedGuide,
    athleteprofile: AthleteProfile,
    headtohead: HeadToHead,
    imagewithdropdown: ImageWithDropDown,
    judgesheadtohead: JudgesHeadToHead,
    judgesresults: JudgesResults,
    knockouttree: KnockOutTree,
    knockouttree2: KnockOutTree2,
    results: Results,
    simpletrack: SimpleTrack,
    checkpointresults: CheckpointResults
  };

  const widgetName = `${config.trackingTitle || config.navigationTitle}`;
  const advertiseAmount = config.advertiseAmount || Infinity;
  const adContext = useContext(AdContext);

  const [showComponent, setShowComponent] = useState({ opacity: 1 });

  // just needed to get state, it should never be updated:
  const [showAd] = useState(
    adContext.adInfos[widgetName]
      ? adContext.adInfos[widgetName].count < advertiseAmount
      : true
  );

  const showAdvert = () => {
    return showAd;
  };

  useEffect(() => {
    if (showAdvert()) {
      setShowComponent({ opacity: 0 });
    }

    const currentNum = adContext.adInfos[widgetName]
      ? adContext.adInfos[widgetName].count
      : 0;

    adContext.changeAdInfos({
      [widgetName]: {
        count: currentNum + 1
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let componentName = config.module.type;
  if (componentName === 'judges-results') componentName = 'judgesresults';

  const Component = allComponents[componentName.toLowerCase()];

  return (
    <>
      <motion.div
        className="appRow wipe"
        initial={{ opacity: 0 }}
        animate={showComponent}
        key={config.navigationTitle}
      >
        <Component
          key={`module-${config.module.type.toLowerCase()}-${config.module.navigationTitle.toLowerCase()}`}
          config={{
            ...config.module,
            trackingTitle: `${
              config.module.trackingTitle || config.module.navigationTitle
            }`
          }}
        />
      </motion.div>
      {showAdvert() && (
        <WipeAdvertisement
          advertising={config.advertisingUri}
          setShowComponent={setShowComponent}
        />
      )}
    </>
  );
};

export { Wipe };
